define('modules/editor/behaviours/lib/hover_layers',['require','exports','module','base/class','i18n'],function(require, exports) {
  "use strict";

  var Class = require("base/class"),  i18n = require("i18n");

  var InjectableView = Class.extend({}, {
    html: "",
    prevEl: null,
    injectIn: function(el) {
      if (this.prevEl) { this.removeFrom(this.prevEl); }
      $(el).prepend(this.html);
      $(el).i18n();
      this.prevEl = el;
    },
    removeFrom: function(el) {
      $(el).find(".hover-box,.ed-item-info").remove();
      this.prevEl = null;
    }
  });

  exports.NormalHover = InjectableView.extend({}, {
    html: "<span class=\"ed-item-info i18n\" data-i18n=\"common.clickToEdit\">Click para editar</span>"
  });

  exports.DragOver = InjectableView.extend({}, {
    html: "<span class=\"ed-item-info i18n\" data-i18n=\"common.letElementHere\">Suelta el elemento aquí</span>"
  });

  exports.DragForbidden = InjectableView.extend({}, {
    html: "blih"
  });

});

